import { CraftContent } from "../../api/craft/craftContent";

const STORAGE_VOTING = 'voting'
const STORAGE_HAS_VOTED = 'votingHasVoted'

class Voting {
  constructor(element) {
    this.element = element
    this.votingField = document.getElementById('voting')
    this.votingContactField = document.getElementById('voting-contact-data')
    this.votingChoicesEl = this.element.querySelector('.voting__choices')
    this.votingForm = this.element.querySelector('.voting__form')
    this.votingSubmit = document.getElementById('voting-submit')
    this.contactForm = document.getElementById('voting-contact')
    this.contactSection = document.getElementById('voting-contact-form')
    this.contactSubmit = document.getElementById('voting-contact-submit')
    this.contactError = this.element.querySelector('[data-voting-contact-error]')
    // Sites still on OneLog (Dorf, Landliebe). Contact-form flow when false.
    this.useOneLog = this.votingForm?.dataset.votingMode === 'onelog'
    this.votingLegend = this.element.querySelector('.voting__legend')
    this.votingChoices = [...this.element.querySelectorAll('.voting__choice')]
    this.candidates = this.element.querySelector('[data-candidates]')
    this.placesEl = this.element.querySelector('.voting__places')
    this.places = [...this.element.querySelectorAll('.voting__place')]
    this.footer = document.querySelector('.footer')
    this.checkedSvg = '<svg width="15" height="11" viewBox="0 0 15 11" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path d="M1.40039 5.45487L5.2787 9L13.4004 1" stroke="currentColor" fill="none" stroke-width="2" stroke-miterlimit="10"/>\n' +
      '</svg>'
    this.translations = {
      successTitle: this.votingForm?.dataset.successTitle,
      successText: this.votingForm?.dataset.successText,
    }
    this.nbrOfPlaces = this.places.length

    this.dropdowns = [...this.element.querySelectorAll('.dropdown')]
    this.votingChoicesToggles = [...this.element.querySelectorAll('[data-choices-toggler]')]
    this.disclaimer = this.element.querySelector('[data-disclaimer-desktop]')

    this.init()

  }

  init() {
    if (!this.useOneLog && this.hasVotedLocally()) {
      this.applyAlreadyVotedUi()
      return
    }

    this.initSelectionFromStorage()
    this.rankingSelectionHandle()
    if (this.useOneLog) {
      this.voteSubmitHandle()
    } else {
      this.continueToContactHandle()
      this.contactSubmitHandle()
      this.dateOfBirthValidityHandle()
    }
    this.showSelection()
  }

  hasVotedLocally() {
    return localStorage.getItem(STORAGE_HAS_VOTED) === '1'
  }

  applyAlreadyVotedUi() {
    localStorage.removeItem(STORAGE_VOTING)
    if (this.contactSection) {
      this.contactSection.hidden = true
    }
    this.revealSponsorLinks()
    if (this.votingSubmit) {
      this.votingSubmit.remove()
    }
    if (this.votingLegend && this.translations.successTitle) {
      this.votingLegend.innerText = this.translations.successTitle
    }
    if (this.votingChoicesEl) {
      this.votingChoicesEl.remove()
    }
    if (this.placesEl) {
      this.placesEl.remove()
    }
    this.votingChoicesToggles.forEach(item => item.remove())
    if (this.votingLegend && this.translations.successText && !this.element.querySelector('.voting__success')) {
      this.votingLegend.insertAdjacentHTML(
        'afterend',
        `<p class="voting__success subtitle">${this.translations.successText}</p>`
      )
    }
  }

  initSelectionFromStorage() {
    if (!this.votingSubmit || !this.votingField) {
      localStorage.removeItem(STORAGE_VOTING)
      return false
    }

    let votingFieldValue = []
    try {
      const raw = localStorage.getItem(STORAGE_VOTING)
      votingFieldValue = raw ? JSON.parse(raw) : []
      if (!Array.isArray(votingFieldValue)) {
        votingFieldValue = []
      }
    } catch {
      localStorage.removeItem(STORAGE_VOTING)
      votingFieldValue = []
    }

    this.syncVotingFields(votingFieldValue)
    this.checkSubmissionPossible(votingFieldValue.length)
    this.updateChoices(votingFieldValue)
  }

  syncVotingFields(votingFieldValue) {
    const value = JSON.stringify(votingFieldValue)
    if (this.votingField) {
      this.votingField.value = value
    }
    if (this.votingContactField) {
      this.votingContactField.value = value
    }
  }

  showSelection() {
    this.votingChoicesToggles.map(item => {
      item.addEventListener('click', (event) => {
        event.preventDefault()
        const target = this.element.querySelector(item.dataset.target)
        target.classList.toggle(item.dataset.classes)
        this.votingChoicesToggles.map(item => {
          item.ariaExpanded = target.classList.contains(item.dataset.classes) ? 'true' : 'false'
          return item
        })
      })
    })
  }

  rankingSelectionHandle() {
    if (!this.candidates) {
      return
    }

    this.candidates.addEventListener('click', (e) => {
      const rankingTarget = e.target.closest('[data-ranking]')
      if (rankingTarget) {
        const details = rankingTarget.closest('.dropdown')
        const ranking = rankingTarget.dataset.ranking
        const candidate = rankingTarget.closest('.candidate-teaser')
        details?.toggleAttribute('open', false)
        let votingFieldValue = []
        try {
          votingFieldValue = JSON.parse(this.votingField?.value || '[]')
        } catch {
          votingFieldValue = []
        }

        if (!Array.isArray(votingFieldValue)) {
          return this.syncVotingFields([])
        }

        this.rankingFieldHandle(
          votingFieldValue,
          {
            ranking: parseInt(ranking),
            id: parseInt(candidate.dataset.id),
            name: candidate.querySelector('.h5').textContent,
          }
        )
      } else if (e.target.closest('.dropdown__toggle')) {
        const currentDropdown = e.target.closest('.dropdown')
        this.dropdowns.map(dropdown => {
          if (dropdown !== currentDropdown) {
            dropdown.toggleAttribute('open', false)
          }
          return dropdown
        })
      } else {
        return false
      }
    })
  }

  continueToContactHandle() {
    this.votingSubmit?.addEventListener('click', (e) => {
      e.preventDefault()
      let votingFieldValue = []
      try {
        votingFieldValue = JSON.parse(this.votingField?.value || '[]')
      } catch {
        votingFieldValue = []
      }

      if (!Array.isArray(votingFieldValue) || votingFieldValue.length < this.nbrOfPlaces) {
        return false
      }

      this.syncVotingFields(votingFieldValue)
      this.contactSection?.removeAttribute('hidden')
      this.contactSection?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }

  dateOfBirthValidityHandle() {
    if (!this.contactForm) {
      return
    }

    const dateInput = this.contactForm.querySelector('[name="fields[address][dateOfBirth]"]')
    const ageError = this.contactForm.dataset.errorAge
    if (!dateInput || !ageError) {
      return
    }

    const syncValidity = () => {
      dateInput.setCustomValidity(dateInput.validity.rangeOverflow ? ageError : '')
    }

    dateInput.addEventListener('input', syncValidity)
    dateInput.addEventListener('change', syncValidity)
    dateInput.addEventListener('invalid', syncValidity)
  }

  contactSubmitHandle() {
    if (!this.contactForm) {
      return
    }

    this.contactForm.addEventListener('submit', async (e) => {
      e.preventDefault()
      this.hideContactError()

      let votingFieldValue = []
      try {
        votingFieldValue = JSON.parse(this.votingField?.value || this.votingContactField?.value || '[]')
      } catch {
        votingFieldValue = []
      }

      if (!Array.isArray(votingFieldValue) || votingFieldValue.length < this.nbrOfPlaces) {
        this.showContactError(this.contactForm.dataset.errorIncomplete || 'Please complete your selection.')
        this.votingSubmit?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return false
      }

      if (!this.isAdult(this.contactForm.querySelector('[name="fields[address][dateOfBirth]"]')?.value)) {
        this.showContactError(this.contactForm.dataset.errorAge || 'You must be at least 18 years old.')
        return false
      }

      this.syncVotingFields(votingFieldValue)
      const formData = new FormData(this.contactForm)
      formData.set('voting', JSON.stringify(votingFieldValue))

      if (this.contactSubmit) {
        this.contactSubmit.disabled = true
      }

      try {
        const response = await fetch(this.contactForm.action, {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
          },
        })

        const result = await response.json().catch(() => null)

        if (response.ok && result?.success) {
          localStorage.removeItem(STORAGE_VOTING)
          localStorage.setItem(STORAGE_HAS_VOTED, '1')
          this.votingSuccess()
          return
        }

        this.showContactError(result?.message || result?.error || response.statusText)
      } catch (err) {
        console.log('Failed to submit the vote:', err)
        this.showContactError('An unexpected error occurred while submitting your vote.')
      } finally {
        if (this.contactSubmit) {
          this.contactSubmit.disabled = false
        }
      }
    })
  }

  /**
   * Submit selections while logged in via OneLog.
   */
  voteSubmitHandle() {
    if (!this.votingForm) {
      return
    }

    this.votingForm.addEventListener('submit', async (e) => {
      e.preventDefault()
      this.votingChoicesEl && (this.votingChoicesEl.disabled = true)
      if (!this.votingField) {
        return false
      }

      let votingFieldValue = []
      try {
        votingFieldValue = JSON.parse(this.votingField.value || '[]')
      } catch {
        votingFieldValue = []
      }

      if (!Array.isArray(votingFieldValue) || votingFieldValue.length < this.nbrOfPlaces) {
        return false
      }

      const formData = new FormData(this.votingForm)
      formData.set('voting', JSON.stringify(votingFieldValue))

      try {
        const response = await fetch(this.votingForm.action, {
          method: 'POST',
          body: formData,
        })

        if (response.ok) {
          const result = await response.json()
          if (result.success) {
            localStorage.removeItem(STORAGE_VOTING)
            this.votingSuccess()
          } else {
            console.log(`Error: ${result.error}`)
          }
        } else {
          console.log(`Error: ${response.statusText}`)
        }
      } catch (err) {
        console.log('Failed to submit the vote:', err)
        alert('An unexpected error occurred while submitting your vote.')
      }
    })
  }

  isAdult(dateOfBirth) {
    if (!dateOfBirth) {
      return false
    }
    const birth = new Date(dateOfBirth)
    if (Number.isNaN(birth.getTime())) {
      return false
    }
    const limit = new Date()
    limit.setFullYear(limit.getFullYear() - 18)
    return birth <= limit
  }

  showContactError(message) {
    if (!this.contactError) {
      alert(message)
      return
    }
    this.contactError.hidden = false
    this.contactError.textContent = message
  }

  hideContactError() {
    if (!this.contactError) {
      return
    }
    this.contactError.hidden = true
    this.contactError.textContent = ''
  }

  votingSuccess() {
    if (this.contactSection) {
      this.contactSection.hidden = true
    }

    if (this.votingLegend && this.translations.successTitle) {
      this.votingLegend.innerText = this.translations.successTitle
    }
    this.votingChoicesEl?.remove()
    this.placesEl?.remove()
    this.votingChoicesToggles.map(item => {
      item.remove()
      return item
    })

    if (this.votingLegend && this.translations.successText) {
      this.votingLegend.insertAdjacentHTML(
        'afterend',
        `<p class="voting__success subtitle">${this.translations.successText}</p>`)
    }

    if (this.votingSubmit) {
      const text = this.votingSubmit.querySelector('.action__text')
      text?.classList.toggle('display-none')
      this.votingSubmit.insertAdjacentHTML('beforeend', this.checkedSvg)
      this.votingSubmit.disabled = true
    }

    if (!this.useOneLog) {
      this.revealSponsorLinks()
      this.openSponsorThanksDialog()
    }
  }

  revealSponsorLinks() {
    this.element.querySelectorAll('.candidate-teaser__footer:not([data-sponsor-link])').forEach(footer => {
      footer.hidden = true
    })
    this.element.querySelectorAll('[data-sponsor-link]').forEach(link => {
      link.hidden = false
    })
  }

  openSponsorThanksDialog() {
    const dialog = document.getElementById('dialog-sponsor-thanks')
    if (dialog && dialog.nodeName === 'DIALOG' && !dialog.open) {
      dialog.showModal()
    }
  }


  rankingFieldHandle(votingFieldValue, newRankingElement) {

    // Remove any object that matches the `id` of the new element
    votingFieldValue = votingFieldValue.filter(item => item.id !== newRankingElement.id);

    // Remove any object that matches the `ranking` of the new element
    votingFieldValue = votingFieldValue.filter(item => item.ranking !== newRankingElement.ranking);

    // Add the new element
    votingFieldValue = [...votingFieldValue, newRankingElement]

    // Sort the array by ranking to ensure it stays in order
    votingFieldValue.sort((a, b) => a.ranking - b.ranking);

    // Limit array to a maximum three rankings (0, 1, 2)

    votingFieldValue = votingFieldValue.slice(0, this.nbrOfPlaces);

    this.checkSubmissionPossible(votingFieldValue.length)
    this.updateChoices(votingFieldValue)

    localStorage.setItem(STORAGE_VOTING, JSON.stringify(votingFieldValue))
    this.syncVotingFields(votingFieldValue)

  }


  checkSubmissionPossible(votingFieldValueLength) {
    const isComplete = votingFieldValueLength >= this.nbrOfPlaces
    if (this.votingChoicesEl) {
      this.votingChoicesEl.disabled = !isComplete
    }
    this.votingChoicesToggles.map(item => {
      item.disabled = !isComplete
      return item
    })
    this.disclaimer?.toggleAttribute('hidden', !isComplete)
  }

  updateChoices(votingFieldValue) {
    this.votingChoices.map((item, key) => {
      item.innerText = (votingFieldValue.find(item => item.ranking === key))?.name ?? item.dataset.defaultText
      return item
    })

    this.places.map((item, key) => {
      item.classList.toggle('voting__place--filled', votingFieldValue.findIndex(item => item.ranking === key) > -1)
      item.innerHTML = votingFieldValue.find(item => item.ranking === key) ? this.checkedSvg : key + 1
      return item
    })

    this.element.querySelectorAll('[data-ranking]').forEach(btn => {
      const ranking = parseInt(btn.dataset.ranking)
      const candidateId = parseInt(btn.closest('.candidate-teaser')?.dataset.id)
      const isSelected = votingFieldValue.some(
        item => item.ranking === ranking && item.id === candidateId
      )
      btn.toggleAttribute('disabled', isSelected)
    })

    this.dropdowns.forEach(dropdown => {
      const candidateId = parseInt(dropdown.closest('.candidate-teaser')?.dataset.id)
      const selection = votingFieldValue.find(item => item.id === candidateId)
      const summaryText = dropdown.querySelector('.action__text')
      if (!summaryText) {
        return
      }

      if (!summaryText.dataset.defaultText) {
        summaryText.dataset.defaultText = summaryText.textContent
      }

      summaryText.textContent = selection
        ? dropdown.querySelector(`[data-ranking="${selection.ranking}"]`)?.textContent
          ?? summaryText.dataset.defaultText
        : summaryText.dataset.defaultText
    })
  }
}

export default Voting
